import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contractTypes: [],
  editableContractTypes: [],
  isEditing: false,
  isDirty: false,
  isLoading: false,
  isLocked: false,
  lockedBy: "",
};

export const contractTypesSlice = createSlice({
  name: "contractTypes",
  initialState,
  reducers: {
    setContractTypes(state, { payload = [] }) {
      state.contractTypes = payload;
    },
    setEditableContractTypes(state, { payload = [] }) {
      state.editableContractTypes = payload;
    },
    addType(state, { payload }) {
      const { type, index } = payload;
      state.isDirty = true;
      state.editableContractTypes = [
        ...state.editableContractTypes.slice(0, index + 1),
        type,
        ...state.editableContractTypes.slice(index + 1),
      ];
    },
    updateType(state, { payload = {} }) {
      const { type, index } = payload;
      state.isDirty = true;
      state.editableContractTypes = state.editableContractTypes.map(
        (item, i) => (i === index ? { ...item, ...type } : item)
      );
    },
    removeType(state, action) {
      const index = action.payload;
      state.isDirty = true;
      state.editableContractTypes = state.editableContractTypes.filter(
        (_, i) => i !== index
      );
    },
    setIsEditing(state, { payload }) {
      state.isEditing = Boolean(payload);
    },
    setIsDirty(state, { payload }) {
      state.isDirty = Boolean(payload);
    },
    setIsLoading(state, { payload }) {
      state.isLoading = Boolean(payload);
    },
    setIsLocked(state, { payload }) {
      state.isLocked = Boolean(payload);
    },
    setLockedBy(state, { payload }) {
      state.lockedBy = payload;
    },
  },
});

export const {
  setContractTypes,
  setEditableContractTypes,
  addType,
  updateType,
  removeType,
  setIsEditing,
  setIsDirty,
  setIsLoading,
  setIsLocked,
  setLockedBy,
} = contractTypesSlice.actions;

export default contractTypesSlice.reducer;
